import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

/**
 * Portal — renders children into a detached node appended to document.body.
 * Keeps overlay content out of the normal flow so it can't be clipped by
 * `overflow:hidden` ancestors or trapped under legacy z-index stacks.
 */
const Portal = ({ children, className }) => {
  const [host] = useState(() => {
    if (typeof document === 'undefined') return null;
    const el = document.createElement('div');
    el.setAttribute('data-ps-portal', '');
    if (className) el.className = className;
    return el;
  });

  useEffect(() => {
    if (!host) return undefined;
    document.body.appendChild(host);
    return () => {
      if (host.parentNode) host.parentNode.removeChild(host);
    };
  }, [host]);

  if (!host) return null;
  return createPortal(children, host);
};

export default Portal;
